// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:opsz@9..40&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Godo';
  font-style: normal;
  font-weight: 400;
  src: url('//cdn.jsdelivr.net/korean-webfonts/1/corps/godo/Godo/GodoM.woff2') format('woff2'), url('//cdn.jsdelivr.net/korean-webfonts/1/corps/godo/Godo/GodoM.woff') format('woff');
}

@font-face {
  font-family: 'Godo';
  font-style: normal;
  font-weight: 700;
  src: url('//cdn.jsdelivr.net/korean-webfonts/1/corps/godo/Godo/GodoB.woff2') format('woff2'), url('//cdn.jsdelivr.net/korean-webfonts/1/corps/godo/Godo/GodoB.woff') format('woff');
}

.inner {
  max-width: 1100px;
  margin: 0 auto;
}

body::-webkit-scrollbar,
.react-responsive-modal-modal::-webkit-scrollbar,
.react-responsive-modal-container::-webkit-scrollbar {
  display: none;
}

.fp-scroll-mac .fp-overflow::-webkit-scrollbar {
  background-color: transparent;
  width: 0 !important;
}

/* 마우스 커서 변경 */
body,
* {
  cursor: none;
}

.cursor {
  position: fixed;
  width: 25px;
  height: 25px;
  pointer-events: none;
  z-index: 999;
  top: 0;
  left: 0;
  cursor: none;
  border-radius: 100%;
  border: 2px solid #000;
  pointer-events: none;
  transition: transform 0.3s ease, background-color 0.3s ease;
}

/* .cursor svg{
  width: 10px;
  position: absolute;
  top: 30px;
  left: 30px;
  animation:rot 3s linear infinite;
  transform-origin:bottom left;
}
.cursor svg path{
  stroke: 2px;
}

.cursor.sizeUp svg{
  display: none;
} */
@keyframes rot {
  0% {
    transform: translate(0, 0) rotate(0deg);
  }

  100% {
    transform: translate(0, 0) rotate(360deg);
  }
}

.cursor span {
  border-radius: 100%;
  background-color: #fff;
  width: 100%;
  height: 100%;
  display: block;
}

.cursor.sizeUp {
  transform: scale(2);
  mix-blend-mode: difference;
}

@media screen and (max-width:1280px) {

  body,
  * {
    cursor: default;
  }

  .cursor {
    display: none;
  }
}


.whiteBg {
  background-color: #fff;
}

/* 공통 css */
.introTitle {
  color: #fff;
  font-weight: 900;
  font-size: 90px;
  line-height: 120%;
  text-align: center;
}

.introTitle span {
  color: #EBFF00;
}

.title {
  font-size: 72px;
  font-weight: 800;
  line-height: 120%;
  color: #000;
}

.introText {
  color: #fff;
  font-size: 28px;
  font-weight: 400;
  text-align: center;
  line-height: 134%
}

.introText span {
  color: #EBFF00;
}

.aboutWrap {
  /* background-size:578px;
  background-image: url(../img/aboutBg.png);
  background-position: center;
  background-repeat: no-repeat; */
  background-color: #fff;
}

.section {
  overflow: hidden;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.section .action {
  opacity: 0.5;
  transition: transform 0.4s ease 0.4s, opacity 0.4s ease 0.4s;
  transform: translateY(50px);
}

.section.active .action {
  opacity: 1;
  transform: translateY(0);
}

.section .action1 {
  opacity: 0.5;
  transition: transform 0.3s, opacity 0.3s;
  transform: translateY(20px);
}

.section.active .action1 {
  opacity: 1;
  transform: translateY(0);
}

.aboutBg {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transition: all 0.5s;
  overflow: initial;
}

.aboutBg path {
  opacity: 1;
  transform: scale(1);
  transform-origin: center center;
  animation: fadeIn 3.5s infinite;
  transition: opacity 0.1s linear, transform 0.1s linear;
}

.aboutBg path:nth-child(1) {
  animation-delay: 0.1s;
}

.aboutBg path:nth-child(2) {
  animation-delay: 0.2s;
}

.aboutBg path:nth-child(3) {
  animation-delay: 0.3s;
}

.aboutBg path:nth-child(4) {
  animation-delay: 0.4s;
}

.aboutBg path:nth-child(5) {
  animation-delay: 0.5s;
}

.aboutBg path:nth-child(6) {
  animation-delay: 0.6s;
}

.aboutBg path:nth-child(7) {
  animation-delay: 0.7s;
}

.aboutBg path:nth-child(8) {
  animation-delay: 0.8s;
}

.aboutBg path:nth-child(9) {
  animation-delay: 0.9s;
}

.aboutBg path:nth-child(10) {
  animation-delay: 1s;
}

.aboutBg path:nth-child(11) {
  animation-delay: 1.1s;
}

.aboutBg path:nth-child(12) {
  animation-delay: 1.2s;
}

.aboutBg path:nth-child(13) {
  animation-delay: 1.3s;
}

.aboutBg path:nth-child(14) {
  animation-delay: 1.4s;
}

.aboutBg path:nth-child(15) {
  animation-delay: 1.5s;
}

.aboutBg path:nth-child(16) {
  animation-delay: 1.6s;
}

.aboutBg path:nth-child(17) {
  animation-delay: 1.7s;
}

.aboutBg path:nth-child(18) {
  animation-delay: 1.8s;
}

.aboutBg path:nth-child(19) {
  animation-delay: 1.9s;
}

.aboutBg path:nth-child(20) {
  animation-delay: 2s;
}

.aboutBg path:nth-child(21) {
  animation-delay: 2.1s;
}

.aboutBg path:nth-child(22) {
  animation-delay: 2.2s;
}

.aboutBg path:nth-child(23) {
  animation-delay: 2.3s;
}

.aboutBg path:nth-child(24) {
  animation-delay: 2.4s;
}

.aboutBg path:nth-child(25) {
  animation-delay: 2.5s;
}

.aboutBg path:nth-child(26) {
  animation-delay: 2.6s;
}

.aboutBg path:nth-child(27) {
  animation-delay: 2.7s;
}

.aboutBg path:nth-child(28) {
  animation-delay: 2.8s;
}

.aboutBg path:nth-child(29) {
  animation-delay: 2.9s;
}

.aboutBg path:nth-child(30) {
  animation-delay: 3s;
}

.aboutBg path:nth-child(31) {
  animation-delay: 3.1s;
}

.aboutBg path:nth-child(32) {
  animation-delay: 3.2s;
}

.aboutBg path:nth-child(33) {
  animation-delay: 3.3s;
}

.aboutBg path:nth-child(34) {
  animation-delay: 3.4s;
}

.aboutBg path:nth-child(35) {
  animation-delay: 3.5s;
}

@keyframes fadeIn {
  0% {
    opacity: 0.5;
    transform: scale(0.8);
    transform-origin: center center;
  }

  100% {
    opacity: 1;
    transform: scale(1);
    transform-origin: center center;

  }
}

.swiperWrap .fp-overflow {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  position: relative;
}

.swiperWrap {
  padding: 160px 0 167px;
}

.bigImg {
  width: 950px;
  height: 629px;
  margin: 0;
  float: left;
  margin-right: 20px !important;
  overflow: hidden;
}

.thumbSwiper {
  height: 190px;
  width: calc(100% - 970px);
}

.bigImg img {
  width: 100%
}

.thumbSwiper img {
  width: 100%;
}

.swiperTxtWrap {
  padding: 0 43px;
  position: absolute;
  left: 970px;
  bottom: 250px;
  width: calc(100% - 970px);
  opacity: 0.2;
  transition: all 0.5s;

}

.swiperTxtWrap li {
  color: #fff;
  font-weight: 500;
  font-size: 28px;
  line-height: 38px;
}

.swiperTxtWrap .logo {
  margin-bottom: 18px;
}

.swiperWrap.active .swiperTxtWrap {
  opacity: 1;
  transition-delay: 0.5s;
}

input:-internal-autofill-selected {
  background-color: transparent;
}

.port-header {
  background-color: initial !important;
  -webkit-backdrop-filter: initial !important;
          backdrop-filter: initial !important;
}

.godo-b {
  font-family: 'Godo', sans-serif;
  font-weight: 700;
}

.fs-50px {
  font-size: 50px;
}

.port-line {
  width: 100%;
  height: 7px;
  margin-bottom: 10px;
}

.bg-white {
  background-color: white;
}

.bg-black {
  background-color: #000;
}

.fc-white {
  color: white
}

.fc-black {
  color: #000
}

.mb-30px {
  margin-bottom: 30px;
}

.fs-26px {
  font-size: 26px;
}

.d-inline-block {
  display: inline-block;
}

.w-max-558px {
  max-width: 558px;
}

.view-more-btn {
  display: flex;
  align-items: center;
  padding: 6px 49px;
  width: 196px;
}

.view-more-white {
  background-color: #D8D8D8;
}

.view-more-black {
  background-color: #000;
}

.view-more-btn div {
  font-size: 20px;
  margin-right: 4px;
}

.port-box {
  padding: 0 100px;
  /* padding-bottom: 230px; */
}

.more-box {
  background-color: rgba(255, 255, 255, 0.20) !important;
}

.more-text {
  display: flex;
  align-items: center;
}

.more-text div {
  font-family: 'DM Sans', sans-serif;
  color: #fff;
  font-size: 40px;
  margin-right: 4px;
}

.port-subject {
  letter-spacing: -0.52px;
  line-height: normal;
}

.react-responsive-modal-modal {
  max-width: 1400px !important;
  width: 90%;
  padding: 0 !important;
  border-radius: 10px;
  margin-top: 130px !important;
  margin-bottom: 130px !important;
}

.react-responsive-modal-closeButton {
  display: none !important;
}

.port-detail-img {
  width: 100%;
  object-fit: cover;
}

.file-down {
  border: 1px solid #fff;
  font-size: 20px;
  letter-spacing: -0.4px;
  padding: 6px 49px;
  font-weight: 400;
  display: flex;
  align-items: center;
  width: 213px;
  height: 38px;
}

.file-down img {
  margin-left: 4px;
}

.position-relative {
  position: relative
}

.file-down-box {
  display: flex;
  justify-content: center;
}

.more-modal {
  padding: 90px 100px;
}

.more-title {
  font-size: 80px;
  font-weight: 800;
  margin-bottom: 70px;
}

.more-logo {
  position: absolute;
  top: 14px;
  right: 0;
  z-index: -1;
}

.more-table {
  display: flex;
}

.more-table:nth-child(odd) {
  background-color: #fff;
}

.more-table:nth-child(even) {
  background-color: #F4F4F4;
}

.more-table div {
  padding: 10px;
  letter-spacing: -0.52px;
  font-size: 25px;
  line-height: normal;
  display: flex;
  align-items: center;
}

.more-table div:first-child {
  max-width: 220px;
  width: 20%;
  font-weight: 700;
}

.more-table div:last-child {
  width: 80%;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/global.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mLAAmL;AACrL;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mLAAmL;AACrL;;AAIA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA,cAAc;AACd;;EAEE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,MAAM;EACN,OAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;;;;;;;;;;;;;;GAcG;AACH;EACE;IACE,uCAAuC;EACzC;;EAEA;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;;EAEE;;IAEE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF;;;AAGA;EACE,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;;;iCAG+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,4DAA4D;EAC5D,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,+BAA+B;EAC/B,+BAA+B;EAC/B,sDAAsD;AACxD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,YAAY;IACZ,qBAAqB;IACrB,+BAA+B;EACjC;;EAEA;IACE,UAAU;IACV,mBAAmB;IACnB,+BAA+B;;EAEjC;AACF;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,SAAS;EACT,WAAW;EACX,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,oBAAoB;;AAEtB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,2CAAmC;UAAnC,mCAAmC;AACrC;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,UAAU;EACV,qBAAqB;EACrB,mBAAmB;EACnB,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ","sourcesContent":["@font-face {\n  font-family: 'Godo';\n  font-style: normal;\n  font-weight: 400;\n  src: url('//cdn.jsdelivr.net/korean-webfonts/1/corps/godo/Godo/GodoM.woff2') format('woff2'), url('//cdn.jsdelivr.net/korean-webfonts/1/corps/godo/Godo/GodoM.woff') format('woff');\n}\n\n@font-face {\n  font-family: 'Godo';\n  font-style: normal;\n  font-weight: 700;\n  src: url('//cdn.jsdelivr.net/korean-webfonts/1/corps/godo/Godo/GodoB.woff2') format('woff2'), url('//cdn.jsdelivr.net/korean-webfonts/1/corps/godo/Godo/GodoB.woff') format('woff');\n}\n\n@import url('https://fonts.googleapis.com/css2?family=DM+Sans:opsz@9..40&display=swap');\n\n.inner {\n  max-width: 1100px;\n  margin: 0 auto;\n}\n\nbody::-webkit-scrollbar,\n.react-responsive-modal-modal::-webkit-scrollbar,\n.react-responsive-modal-container::-webkit-scrollbar {\n  display: none;\n}\n\n.fp-scroll-mac .fp-overflow::-webkit-scrollbar {\n  background-color: transparent;\n  width: 0 !important;\n}\n\n/* 마우스 커서 변경 */\nbody,\n* {\n  cursor: none;\n}\n\n.cursor {\n  position: fixed;\n  width: 25px;\n  height: 25px;\n  pointer-events: none;\n  z-index: 999;\n  top: 0;\n  left: 0;\n  cursor: none;\n  border-radius: 100%;\n  border: 2px solid #000;\n  pointer-events: none;\n  transition: transform 0.3s ease, background-color 0.3s ease;\n}\n\n/* .cursor svg{\n  width: 10px;\n  position: absolute;\n  top: 30px;\n  left: 30px;\n  animation:rot 3s linear infinite;\n  transform-origin:bottom left;\n}\n.cursor svg path{\n  stroke: 2px;\n}\n\n.cursor.sizeUp svg{\n  display: none;\n} */\n@keyframes rot {\n  0% {\n    transform: translate(0, 0) rotate(0deg);\n  }\n\n  100% {\n    transform: translate(0, 0) rotate(360deg);\n  }\n}\n\n.cursor span {\n  border-radius: 100%;\n  background-color: #fff;\n  width: 100%;\n  height: 100%;\n  display: block;\n}\n\n.cursor.sizeUp {\n  transform: scale(2);\n  mix-blend-mode: difference;\n}\n\n@media screen and (max-width:1280px) {\n\n  body,\n  * {\n    cursor: default;\n  }\n\n  .cursor {\n    display: none;\n  }\n}\n\n\n.whiteBg {\n  background-color: #fff;\n}\n\n/* 공통 css */\n.introTitle {\n  color: #fff;\n  font-weight: 900;\n  font-size: 90px;\n  line-height: 120%;\n  text-align: center;\n}\n\n.introTitle span {\n  color: #EBFF00;\n}\n\n.title {\n  font-size: 72px;\n  font-weight: 800;\n  line-height: 120%;\n  color: #000;\n}\n\n.introText {\n  color: #fff;\n  font-size: 28px;\n  font-weight: 400;\n  text-align: center;\n  line-height: 134%\n}\n\n.introText span {\n  color: #EBFF00;\n}\n\n.aboutWrap {\n  /* background-size:578px;\n  background-image: url(../img/aboutBg.png);\n  background-position: center;\n  background-repeat: no-repeat; */\n  background-color: #fff;\n}\n\n.section {\n  overflow: hidden;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n}\n\n.section .action {\n  opacity: 0.5;\n  transition: transform 0.4s ease 0.4s, opacity 0.4s ease 0.4s;\n  transform: translateY(50px);\n}\n\n.section.active .action {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.section .action1 {\n  opacity: 0.5;\n  transition: transform 0.3s, opacity 0.3s;\n  transform: translateY(20px);\n}\n\n.section.active .action1 {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.aboutBg {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  transition: all 0.5s;\n  overflow: initial;\n}\n\n.aboutBg path {\n  opacity: 1;\n  transform: scale(1);\n  transform-origin: center center;\n  animation: fadeIn 3.5s infinite;\n  transition: opacity 0.1s linear, transform 0.1s linear;\n}\n\n.aboutBg path:nth-child(1) {\n  animation-delay: 0.1s;\n}\n\n.aboutBg path:nth-child(2) {\n  animation-delay: 0.2s;\n}\n\n.aboutBg path:nth-child(3) {\n  animation-delay: 0.3s;\n}\n\n.aboutBg path:nth-child(4) {\n  animation-delay: 0.4s;\n}\n\n.aboutBg path:nth-child(5) {\n  animation-delay: 0.5s;\n}\n\n.aboutBg path:nth-child(6) {\n  animation-delay: 0.6s;\n}\n\n.aboutBg path:nth-child(7) {\n  animation-delay: 0.7s;\n}\n\n.aboutBg path:nth-child(8) {\n  animation-delay: 0.8s;\n}\n\n.aboutBg path:nth-child(9) {\n  animation-delay: 0.9s;\n}\n\n.aboutBg path:nth-child(10) {\n  animation-delay: 1s;\n}\n\n.aboutBg path:nth-child(11) {\n  animation-delay: 1.1s;\n}\n\n.aboutBg path:nth-child(12) {\n  animation-delay: 1.2s;\n}\n\n.aboutBg path:nth-child(13) {\n  animation-delay: 1.3s;\n}\n\n.aboutBg path:nth-child(14) {\n  animation-delay: 1.4s;\n}\n\n.aboutBg path:nth-child(15) {\n  animation-delay: 1.5s;\n}\n\n.aboutBg path:nth-child(16) {\n  animation-delay: 1.6s;\n}\n\n.aboutBg path:nth-child(17) {\n  animation-delay: 1.7s;\n}\n\n.aboutBg path:nth-child(18) {\n  animation-delay: 1.8s;\n}\n\n.aboutBg path:nth-child(19) {\n  animation-delay: 1.9s;\n}\n\n.aboutBg path:nth-child(20) {\n  animation-delay: 2s;\n}\n\n.aboutBg path:nth-child(21) {\n  animation-delay: 2.1s;\n}\n\n.aboutBg path:nth-child(22) {\n  animation-delay: 2.2s;\n}\n\n.aboutBg path:nth-child(23) {\n  animation-delay: 2.3s;\n}\n\n.aboutBg path:nth-child(24) {\n  animation-delay: 2.4s;\n}\n\n.aboutBg path:nth-child(25) {\n  animation-delay: 2.5s;\n}\n\n.aboutBg path:nth-child(26) {\n  animation-delay: 2.6s;\n}\n\n.aboutBg path:nth-child(27) {\n  animation-delay: 2.7s;\n}\n\n.aboutBg path:nth-child(28) {\n  animation-delay: 2.8s;\n}\n\n.aboutBg path:nth-child(29) {\n  animation-delay: 2.9s;\n}\n\n.aboutBg path:nth-child(30) {\n  animation-delay: 3s;\n}\n\n.aboutBg path:nth-child(31) {\n  animation-delay: 3.1s;\n}\n\n.aboutBg path:nth-child(32) {\n  animation-delay: 3.2s;\n}\n\n.aboutBg path:nth-child(33) {\n  animation-delay: 3.3s;\n}\n\n.aboutBg path:nth-child(34) {\n  animation-delay: 3.4s;\n}\n\n.aboutBg path:nth-child(35) {\n  animation-delay: 3.5s;\n}\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0.5;\n    transform: scale(0.8);\n    transform-origin: center center;\n  }\n\n  100% {\n    opacity: 1;\n    transform: scale(1);\n    transform-origin: center center;\n\n  }\n}\n\n.swiperWrap .fp-overflow {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  position: relative;\n}\n\n.swiperWrap {\n  padding: 160px 0 167px;\n}\n\n.bigImg {\n  width: 950px;\n  height: 629px;\n  margin: 0;\n  float: left;\n  margin-right: 20px !important;\n  overflow: hidden;\n}\n\n.thumbSwiper {\n  height: 190px;\n  width: calc(100% - 970px);\n}\n\n.bigImg img {\n  width: 100%\n}\n\n.thumbSwiper img {\n  width: 100%;\n}\n\n.swiperTxtWrap {\n  padding: 0 43px;\n  position: absolute;\n  left: 970px;\n  bottom: 250px;\n  width: calc(100% - 970px);\n  opacity: 0.2;\n  transition: all 0.5s;\n\n}\n\n.swiperTxtWrap li {\n  color: #fff;\n  font-weight: 500;\n  font-size: 28px;\n  line-height: 38px;\n}\n\n.swiperTxtWrap .logo {\n  margin-bottom: 18px;\n}\n\n.swiperWrap.active .swiperTxtWrap {\n  opacity: 1;\n  transition-delay: 0.5s;\n}\n\ninput:-internal-autofill-selected {\n  background-color: transparent;\n}\n\n.port-header {\n  background-color: initial !important;\n  backdrop-filter: initial !important;\n}\n\n.godo-b {\n  font-family: 'Godo', sans-serif;\n  font-weight: 700;\n}\n\n.fs-50px {\n  font-size: 50px;\n}\n\n.port-line {\n  width: 100%;\n  height: 7px;\n  margin-bottom: 10px;\n}\n\n.bg-white {\n  background-color: white;\n}\n\n.bg-black {\n  background-color: #000;\n}\n\n.fc-white {\n  color: white\n}\n\n.fc-black {\n  color: #000\n}\n\n.mb-30px {\n  margin-bottom: 30px;\n}\n\n.fs-26px {\n  font-size: 26px;\n}\n\n.d-inline-block {\n  display: inline-block;\n}\n\n.w-max-558px {\n  max-width: 558px;\n}\n\n.view-more-btn {\n  display: flex;\n  align-items: center;\n  padding: 6px 49px;\n  width: 196px;\n}\n\n.view-more-white {\n  background-color: #D8D8D8;\n}\n\n.view-more-black {\n  background-color: #000;\n}\n\n.view-more-btn div {\n  font-size: 20px;\n  margin-right: 4px;\n}\n\n.port-box {\n  padding: 0 100px;\n  /* padding-bottom: 230px; */\n}\n\n.more-box {\n  background-color: rgba(255, 255, 255, 0.20) !important;\n}\n\n.more-text {\n  display: flex;\n  align-items: center;\n}\n\n.more-text div {\n  font-family: 'DM Sans', sans-serif;\n  color: #fff;\n  font-size: 40px;\n  margin-right: 4px;\n}\n\n.port-subject {\n  letter-spacing: -0.52px;\n  line-height: normal;\n}\n\n.react-responsive-modal-modal {\n  max-width: 1400px !important;\n  width: 90%;\n  padding: 0 !important;\n  border-radius: 10px;\n  margin-top: 130px !important;\n  margin-bottom: 130px !important;\n}\n\n.react-responsive-modal-closeButton {\n  display: none !important;\n}\n\n.port-detail-img {\n  width: 100%;\n  object-fit: cover;\n}\n\n.file-down {\n  border: 1px solid #fff;\n  font-size: 20px;\n  letter-spacing: -0.4px;\n  padding: 6px 49px;\n  font-weight: 400;\n  display: flex;\n  align-items: center;\n  width: 213px;\n  height: 38px;\n}\n\n.file-down img {\n  margin-left: 4px;\n}\n\n.position-relative {\n  position: relative\n}\n\n.file-down-box {\n  display: flex;\n  justify-content: center;\n}\n\n.more-modal {\n  padding: 90px 100px;\n}\n\n.more-title {\n  font-size: 80px;\n  font-weight: 800;\n  margin-bottom: 70px;\n}\n\n.more-logo {\n  position: absolute;\n  top: 14px;\n  right: 0;\n  z-index: -1;\n}\n\n.more-table {\n  display: flex;\n}\n\n.more-table:nth-child(odd) {\n  background-color: #fff;\n}\n\n.more-table:nth-child(even) {\n  background-color: #F4F4F4;\n}\n\n.more-table div {\n  padding: 10px;\n  letter-spacing: -0.52px;\n  font-size: 25px;\n  line-height: normal;\n  display: flex;\n  align-items: center;\n}\n\n.more-table div:first-child {\n  max-width: 220px;\n  width: 20%;\n  font-weight: 700;\n}\n\n.more-table div:last-child {\n  width: 80%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
